import "./Products.module.css";
import Navigation from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import Footer from "@/reusable_sections/Footer";
import ProductCategories from "./sections/ProductCategories";
import ProductFinder from "./sections/ProductFinder";
import ProductsHero from "./sections/ProductsHero";
import QuoteRequest from "./sections/QuoteRequest";
export default function ProductsPage() {
  return <div>
      <Navigation />
      <PageBreadcrumb page="Products" />
      <ProductsHero />
      <ProductCategories />
      <ProductFinder />
      <QuoteRequest />
      <Footer />
    </div>;
}